import { Component } from '@angular/core';
import { brand } from '@app/branding/brand';

@Component({
    selector: 'app-block-template',
    styles: [`
    :host {
      text-align: center;
    }
  `],
    template: `
    @if (message != null) {
      <div class="block-ui-template">
        <i class="spinner-border loader" style="width: 3rem; height: 3rem;" role="status" aria-hidden="true"></i>
        <div ><strong class="message">{{message}}</strong></div>
      </div>
    } @else {
      <div class="block-ui-template">
        <div class="container-loading">
          <img
            src="../../assets/logos/logo-inprovider-white.png"
            width="200"
            height="48"
            class="d-inline-block align-top"
            [attr.alt]="brandName">
        </div>
        <div class="loader-inp">
          <div class="loading"></div>
        </div>
      </div>
    }
    `,
    standalone: false
})
export class BlockTemplateComponent {
  message: any;
  readonly brandName = brand.name;
}
